import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GDPR_CONSTANTS } from 'src/app/core/constants/gdpr.constants';

/**
 * Dezenter Rechts-Footer für die öffentlichen Auth-Seiten (Login/Registrierung/
 * Passwort-vergessen). Verlinkt Impressum, Datenschutz und Nutzungsbedingungen,
 * damit die Impressumspflicht (§5 DDG) auch bei direktem Deeplink/Bookmark auf
 * die App-Subdomain erfüllt ist. URLs stammen aus den zentralen GDPR_CONSTANTS.
 */
@Component({
  selector: 'app-auth-legal-footer',
  templateUrl: './auth-legal-footer.component.html',
  styleUrls: ['./auth-legal-footer.component.css'],
  imports: [CommonModule, TranslateModule],
})
export class AuthLegalFooterComponent {
  readonly imprintUrl = GDPR_CONSTANTS.IMPRINT_URL;
  readonly privacyUrl = GDPR_CONSTANTS.PRIVACY_URL;
  readonly termsUrl = GDPR_CONSTANTS.TERMS_URL;
}
